import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl';

import messages from './messages';
import type { LogTimeModalFooterProps } from './types';

const renderSpinner = () => (
	<SpinnerContainer>
		<Spinner interactionName="issue-worklog-log-time-modal-spinner" size="small" />
	</SpinnerContainer>
);

export const LogTimeModalFooter = (props: LogTimeModalFooterProps) => {
	const intl = useIntl();
	const { formState, onConfirm, onCancel } = props;
	return (
		<RightAligned
			/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
			data-testid="issue.common.component.log-time-modal.modal.footer"
		>
			{formState === 'submitting' ? renderSpinner() : null}
			<Button
				interactionName="issue-worklog"
				appearance="primary"
				onClick={onConfirm}
				isDisabled={formState === 'invalid' || formState === 'submitting'}
				/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
				testId="issue.common.component.log-time-modal.modal.footer.save-button"
			>
				{intl.formatMessage(messages.save)}
			</Button>
			<Button
				appearance="subtle"
				onClick={onCancel}
				isDisabled={formState === 'submitting'}
				interactionName="auto-generated.jira-issue-view-common.component.log-time-modal.modal.footer.button"
			>
				{intl.formatMessage(messages.cancel)}
			</Button>
		</RightAligned>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RightAligned = styled.div({
	display: 'inline-flex',
	justifyContent: 'flex-end',
	alignItems: 'center',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> :not(:first-of-type)': {
		marginLeft: token('space.050', '4px'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerContainer = styled.div({
	/* Needed to vertically align the spinner. */
	/* See: https://ecosystem.atlassian.net/browse/AK-4244 */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> *': {
		display: 'flex',
	},
	marginRight: token('space.100', '8px'),
});
